import { MousePointerClick, Pencil, MessageCircle, MonitorSmartphone } from "lucide-react";
import { Reveal } from "./Reveal";
import { DEMO_BANNER } from "@/data/demoMenu";

const POINTS = [
    { icon: MousePointerClick, text: "Monte um pedido de verdade, do jeito que o cliente final faz" },
    { icon: Pencil, text: "Ative o Modo Dono e edite produtos e preços na hora" },
    { icon: MessageCircle, text: "Veja o pedido chegar formatado direto no WhatsApp" },
];

export const DemoHighlight = () => (
    <section data-testid="demo-highlight-section" className="relative pb-24 sm:pb-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <Reveal>
                <div className="relative overflow-hidden rounded-3xl border border-cyan-400/25 bg-gradient-to-br from-[#0D121F] via-[#0c1626] to-[#0a1a2e]">
                    <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-cyan-400 to-transparent" aria-hidden="true" />
                    <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-[#00D2FF]/10 blur-[100px]" aria-hidden="true" />

                    <div className="grid items-center gap-10 p-8 sm:p-12 lg:grid-cols-2">
                        <div>
                            <span className="inline-flex items-center gap-2 rounded-full border border-cyan-400/30 bg-cyan-400/[0.08] px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.2em] text-cyan-300">
                                <span className="beacon-dot h-2 w-2 rounded-full bg-cyan-400" />
                                Demonstração ao Vivo
                            </span>
                            <h2 className="mt-5 text-3xl font-bold tracking-tight text-slate-50 sm:text-4xl">
                                Teste o cardápio digital agora, na prática
                            </h2>
                            <p className="mt-4 text-base leading-relaxed text-slate-400 sm:text-lg">
                                Nada de prints ou promessas: abra a demonstração, monte um
                                pedido e sinta exatamente o que os clientes do seu
                                restaurante vão vivenciar.
                            </p>
                            <ul className="mt-7 space-y-3.5">
                                {POINTS.map((p) => (
                                    <li key={p.text} className="flex items-start gap-3 text-sm text-slate-300">
                                        <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-lg border border-cyan-400/25 bg-cyan-400/[0.08]">
                                            <p.icon size={14} className="text-cyan-300" />
                                        </span>
                                        {p.text}
                                    </li>
                                ))}
                            </ul>
                            <a
                                href="/demo"
                                data-testid="demo-highlight-button"
                                className="mt-8 inline-flex items-center gap-2.5 rounded-full bg-gradient-to-r from-[#00D2FF] to-[#0088FF] px-8 py-4 text-base font-extrabold text-[#03202e] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_14px_44px_rgba(0,210,255,0.35)]"
                            >
                                <MonitorSmartphone size={19} strokeWidth={2.5} />
                                Testar Demonstração ao Vivo
                            </a>
                        </div>

                        <div className="animate-float-slow relative">
                            <div className="overflow-hidden rounded-2xl border border-white/10 shadow-[0_30px_80px_rgba(0,0,0,0.5)]">
                                <div className="flex items-center gap-1.5 border-b border-white/[0.07] bg-[#0D121F] px-4 py-2.5">
                                    <span className="h-2.5 w-2.5 rounded-full bg-red-400/70" />
                                    <span className="h-2.5 w-2.5 rounded-full bg-yellow-400/70" />
                                    <span className="h-2.5 w-2.5 rounded-full bg-[#25D366]/70" />
                                    <span className="ml-3 rounded-md bg-white/[0.06] px-3 py-1 text-[10px] font-medium text-slate-400">
                                        seucomercio.strondex.tech
                                    </span>
                                </div>
                                <img
                                    src={DEMO_BANNER}
                                    alt="Mesa de restaurante com pratos variados — prévia do cardápio digital"
                                    loading="lazy"
                                    className="h-56 w-full object-cover sm:h-64"
                                />
                                <div className="flex items-center justify-between bg-[#0D121F] px-4 py-3">
                                    <span className="text-xs font-bold text-slate-300">Sabor da Vila · Cardápio Demo</span>
                                    <span className="rounded-full bg-[#25D366]/15 px-2.5 py-1 text-[10px] font-bold text-[#25D366]">
                                        0% comissão
                                    </span>
                                </div>
                            </div>
                            <div className="absolute -bottom-3 -left-3 -z-10 h-full w-full rounded-2xl border border-cyan-400/10" aria-hidden="true" />
                        </div>
                    </div>
                </div>
            </Reveal>
        </div>
    </section>
);
